import { render, staticRenderFns } from "./taskRadioInfo.vue?vue&type=template&id=0064033c&scoped=true"
import script from "./taskRadioInfo.vue?vue&type=script&lang=js"
export * from "./taskRadioInfo.vue?vue&type=script&lang=js"
import style0 from "./taskRadioInfo.vue?vue&type=style&index=0&id=0064033c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0064033c",
  null
  
)

export default component.exports